import { useMutation } from '@tanstack/react-query'
import { apiClient } from 'api/apiClient/apiClient'
import { useTranslation } from 'react-i18next'
import alertStore from 'store/alert/alert'

type ExportSettingsParams = {
  system_id: number
  start_time: ISODateTime
  end_time: ISODateTime
  subtypes?: string[]
}

export const EXPORT_QUERY_KEY = `export`

export function useExportSettingsMutation() {
  const { t } = useTranslation()

  return useMutation({
    mutationFn: async (data: ExportSettingsParams) => apiClient(`export/settings`, { data }),
    onMutate: () => {
      alertStore.info(t(`Exporting settings`))
    },
    onSuccess: () => {
      alertStore.success(t(`Settings exported successfully`))
    },
    onError: () => {
      alertStore.error(t(`Failed to export settings`))
    },
  })
}
